<button *ngIf="showBackButton" class="back-button" mat-icon-button (click)="close()">
  <mat-icon>arrow_back</mat-icon>
</button>
<img id="logo" src="assets/lf3/logo.png" [class.with-back-button]="showBackButton" />
<greco-sign-in-fields [config]="fieldsConfig" (successfulSignIn)="navigate($event)"></greco-sign-in-fields>
<ng-content></ng-content>
